import { StoreAction, XmAction } from 'store/actions';
import { OrderCollection, TransactionCollection } from './models';

export function transactionCollectionReducer(state: TransactionCollection, action: XmAction<TransactionCollection>): TransactionCollection {
    switch (action.type) {
        case StoreAction.GET_TRANSACTIONS_BY_PARAMS:
            return action.payload;
        case StoreAction.CLEAR_TRANSACTION:
            return undefined;
        default:
            return state;
    }
}

export function orderCollectionReducer(state: OrderCollection, action: XmAction<OrderCollection>): OrderCollection {
    switch (action.type) {
        case StoreAction.GET_ORDERS:
            return action.payload;
        case StoreAction.CLEAR_ORDERS:
            return undefined;
        default:
            return state;
    }
}
